import React, { useState, useEffect } from "react";
import ReactDOM from "react-dom";
import { connect } from "react-redux";
import { Redirect, NavLink} from "react-router-dom";
import { Login as LoginComponent } from "zina-dogi-react";
import { actions } from "../redux";
import { utils } from "~/utils";
import logo from "../../assets/imgs/zina-India_BrightBlue.svg";
import nokiaLogo from "../../assets/imgs/NokiaZinaIndia.svg";
import { LoginContainer } from "../components";
import "../components/index.scss"
import background1 from "../../assets/imgs/carrousel/background-BLUE@2x-80.jpg"
import background2 from "../../assets/imgs/carrousel/background-MAGENTA@2x-80.jpg"
import background3 from "../../assets/imgs/carrousel/background-ORANGE@2x-80.jpg"

const backgrounds = [background1, background2, background3];

const getRandomBackground = () => backgrounds[Math.floor(Math.random() * backgrounds.length)];


const Login = (props) => {
    const { error, loggedIn, location } = props;
    const withLocation = location.state ? <Redirect to={location.state.from} /> : <Redirect to="/" />;
    const withLogin = loggedIn ? withLocation : null;
    const items = [
        {
            id: 1,
            src: logo
        }
    ];
    const [backgroundDefault, setBackgroundDefault] = useState(getRandomBackground());

    const handleClick = () => {
        const { history } = props;
        history.push('/login/oidc/');
    }
    useEffect(() => {
        document.title = "ZINA | Login";
        setBackgroundDefault(getRandomBackground())
        const elementParent = document.querySelector('.controls');
        const element = document.createElement('div');
        const alert = document.querySelector('.alert');
        if (alert) {
            alert.remove()
        }

        ReactDOM.unstable_batchedUpdates(() => {
            ReactDOM.render(
                <button
                    type="button"
                    className="sso"
                    onClick={handleClick} >Click here for SSO Login</button>,
                element,
                () => {
                    if (element.firstChild) {
                        elementParent.appendChild(element.firstChild);
                    } else {
                        console.log("No se encontró ningún hijo");
                    }
                }
            );
        });

    }, []);


    const link_forgot_password = () => {
        return (
            <div className='row'>
                <div className='col-md-7'>
                    <NavLink to={`/password-recovery/`}>
                        Forgot Password?
                    </NavLink>
                </div>
            </div>
        )
    }

    const onSubmit = ({ username, password }) => {
        if (username !== "" && password !== "") {
            const { dispatch } = props;
            dispatch(actions.login(username, password));
        }
    };

    const newL = (


        <LoginContainer>
            {withLogin}
            <React.Fragment>
                <LoginComponent
                    error={utils.computeError(error)}
                    nokiaLogo={nokiaLogo}
                    fondo={backgroundDefault}
                    onSubmitLogin={onSubmit}
                    LoginBottom={link_forgot_password()}
                    items={items}
                />
            </React.Fragment>
        </LoginContainer>

    );
    return newL;
}

const mapStateToProps = store => ({
    user: store.auth.user,
    error: store.auth.error,
    loggedIn: store.auth.loggedIn
});

export default connect(mapStateToProps)(Login);
